<template>
<div class="chapter">
<div class="inner_page">
<p class="h1">CONTENTS</p>
<p class="toc"><a href="#/foreword">Foreword, by Kenton Forrest</a></p>
<p class="toc"><a href="#/acknowledgement">Acknowledgements</a></p>
<p class="toc1"><a href="#/chapter01">1. The Ticket to the Future</a></p>
<p class="toc"><span href="#/chapter02" title="Link target outside of Sample">2. Where We Connected with Each Other</span></p>
<p class="toc"><span href="#/chapter03" title="Link target outside of Sample">3. Our Return Ticket</span></p>
<p class="toc1"><span href="#/bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc"><span href="#/author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?0e83d8fe